<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i><strong>Synthèses Portefeuille par Produits</strong>
      </b-card-header>
      <b-card-body>
        <table class="tab_synthese p-2" border="1px">
          <thead>
          <tr>
            <td class="gris-medium p-2" rowspan="2"><b>Famille Produit</b></td>
            <td class="bleu-medium center p-2" rowspan="2"><b>Nb SIREN</b></td>
            <td class="vert-medium center p-2" colspan="5"><b>Effectif affilié</b></td>
          </tr>
          <tr>
            <td class="vert-medium right smaller p-2"><i>Cadres</i></td>
            <td class="vert-medium right smaller p-2"><i>Non-Cadres</i></td>
            <td class="vert-medium right smaller p-2"><i>Autres</i></td>
            <td class="vert-medium right p-2"><b>TOTAL</b></td>
            <td class="vert-medium right smaller p-2"><i>Taux Enc.</i></td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(element, key) in data" :key="key">
            <td class="gris-clair p-2"><b>{{ key || '-' }}</b></td>
            <td class="bleu-clair right p-2"><b> {{ element.NbSIREN }} </b></td>
            <td class="smaller right p-2"> {{ element.NbCadres || '-' }}</td>
            <td class="smaller right p-2">{{ element.NbNonCadres }}</td>
            <td class="smaller right p-2">{{ element.NbAutres || '-' }}</td>
            <td class="vert-clair right p-2"><b>{{ element.NbTotal }}</b></td>
            <td class="smaller right p-2">{{ formatTaux(element.Taux) }}</td>
          </tr>
          <tr>
            <td class="gris-medium p-2"><b>Total Portefeuille</b></td>
            <td class="bleu-medium right p-2"><b> {{total.NbSIREN}}</b></td>
            <td class="vert-medium right smaller p-2"><i>{{total.NbCadres}}</i></td>
            <td class="vert-medium right smaller p-2"><i>{{total.NbNonCadres}}</i></td>
            <td class="vert-medium right smaller p-2"><i>{{total.NbAutres}}</i></td>
            <td class="vert-medium right p-2"><b>{{total.NbTotal}}</b></td>
            <td class="vert-medium right smaller p-2"><i>{{ formatTaux(total.Taux)}}</i></td>
          </tr>
          </tbody>
        </table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../utils/auth";

  export default {
    name: "SyntheseProduit",
    data() {
      return {
        data: [],
        totalSiren: 0,
        total: {
          'NbAutres': 0,
          'NbCadres': 0,
          'NbNonCadres': 0,
          'NbSIREN': 0,
          'NbTotal': 0,
          'Taux': 0,
        },
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.downloadSyntheseProduit();
    },
    methods: {
      downloadSyntheseProduit() {
        let self = this;
        this.$store.commit('IS_LOADING', true);
        this.$axios.get('/espaceGestion/extractions/synthese_produit')
          .then((response) => {
            this.$store.commit('IS_LOADING', false);
            this.data = response.data.data;
            this.totalSiren = response.data.totalSiren;
            this.total = response.data.total;
          })
          .catch(error => {
            self.$store.commit('IS_LOADING', false);
            console.log(error);
          });
      },
      formatTaux(x) {
        return x !== 0 ? parseFloat(x).toFixed(1) + "%" : '0';
      }
    }
  }
</script>

<style scoped>
  .gris-medium {
    background-color: #C8C8C8;
    color: #000000;
  }

  .bleu-medium {
    background-color: #8693BA;
    color: #000000;
  }

  .vert-medium {
    background-color: #8FBC8F;
    color: #000000;
  }

  .gris-clair {
    background-color: #EEEEEE;
    color: #000000;
  }

  .bleu-clair {
    background-color: #ced4e3;
    color: #000000;
  }

  .vert-clair {
    background-color: #CFE3CF;
    color: #000000;
  }

  .center {
    text-align: center;
  }

  .right {
    text-align: right;
  }

  .smaller {
    font-size: 0.9em;
  }

</style>
